import { FormControl, MenuItem, styled } from '@mui/material';

import breakpoints from '../../../../constants/breakpoints';
import { colorPrimary } from '../../../../styles/mui/colors';

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiFormLabel-root': {
    color: 'var(--color-text-regular)',
    fontSize: 'var(--font-lg)',
    padding: 'var(--spacing-tiny)',
  },
  backgroundColor: 'var(--color-grey-lighter)',
  width: 'var(--preference-compose-status-width-desktop)',
  [theme.breakpoints.up(breakpoints.mobileL)]: {
    paddingBlock: 'var(--spacing-big)',
    paddingInline: 'var(--spacing-medium)',
  },
}));

export const StatusListItem = styled(MenuItem)(() => ({
  '&.Mui-selected': {
    '&:focus-within': { backgroundColor: colorPrimary[200] },
    '&:hover': { backgroundColor: colorPrimary[100] },
    backgroundColor: colorPrimary[50],
  },
  '&:focus-visible': {
    boxShadow: 'none',
  },
  padding: 0,
}));
